import "../../../../src/styles/main.css";
import CreatePdfFromUrl from "../../../../src/pages/home/create-pdf-from-url.md";
import AccessibilityAutoTagApi from "../../../../src/pages/home/accessbility-auto-tag.md";
import DynamicPdfDocumentGeneration from "../../../../src/pages/home/dynamic-pdf-document-generation.md";
import ExtractPdfContentStructure from "../../../../src/pages/home/pdf-content-structure.md";
import EmbedPdfViewingAnalytics from "../../../../src/pages/home/embed-pdf-viewing-analytics.md";
import WhyDocument from "../../../../src/pages/home/why-document.md";
import HomeCarousel from "../../../../src/pages/home/home-carousel.md";
import CustomerStory from "../../../../src/pages/home/home-storyies.md";
import { APIPixelRetargeting } from "../../../../src/components/retargetting";
import EsealApiAnnouncement from "../../../../src/pages/apis/e-seal-api-announcement.md";
import AnimationVideo from "../../../../src/pages/videos/Adobe_DCP_Marquee_Animation.json";
import ESealAPI from "../../../../src/pages/home/e-seal.md";
import * as React from 'react';
export default {
  CreatePdfFromUrl,
  AccessibilityAutoTagApi,
  DynamicPdfDocumentGeneration,
  ExtractPdfContentStructure,
  EmbedPdfViewingAnalytics,
  WhyDocument,
  HomeCarousel,
  CustomerStory,
  APIPixelRetargeting,
  EsealApiAnnouncement,
  AnimationVideo,
  ESealAPI,
  React
};